import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { MenuIcon } from './icons/MenuIcon';
import { MenuLinks } from './links/MenuLinks';
import { MenuLinkDataProps } from './links/MenuLink';
import { EditionDataProps } from '../Editions';
import { MEDIA_BREAKPOINTS } from '../../../../../../mediaQueries.const';

export interface MenuDataProps {
  menu: MenuLinkDataProps[]
  editions: EditionDataProps[] | null
  editionEndpoint: string
}

interface MenuState {
  isMenuOpen: boolean
  currentOpenLink: number | null
}

const getMenuStyle = () => StyleSheet.create({
  style: {
    [MEDIA_BREAKPOINTS.X_LARGE]: {
      display: 'none',
    },
    [MEDIA_BREAKPOINTS.LARGE]: {
      display: 'none',
    },
    [MEDIA_BREAKPOINTS.MEDIUM]: {
      display: 'inline-flex',
    },
    [MEDIA_BREAKPOINTS.SMALL]: {
      display: 'inline-flex',
    },
  },
});

export class Menu extends React.Component<MenuDataProps, MenuState> {
  constructor(props: MenuDataProps) {
    super(props);
    this.state = {
      isMenuOpen: false,
      currentOpenLink: null,
    };
  }

  clickOnMenuIcon = () => {
    const { isMenuOpen, currentOpenLink } = this.state;
    this.setState({
      isMenuOpen: !isMenuOpen,
      currentOpenLink: isMenuOpen ? currentOpenLink : null,
    });
  };

  clickOnLinkDropDown = (index: number) => {
    const { currentOpenLink } = this.state;
    this.setState({
      currentOpenLink: currentOpenLink === index ? null : index,
    });
  };

  render() {
    const { isMenuOpen, currentOpenLink } = this.state;
    const { menu, editions, editionEndpoint } = this.props;
    const style = getMenuStyle();
    return (
      <div className={css(style.style)}>
        <MenuIcon isMenuOpen={isMenuOpen} onClick={this.clickOnMenuIcon} />
        <MenuLinks menuLinks={menu} editions={editions} isMenuOpen={isMenuOpen} onClick={this.clickOnLinkDropDown} currentOpenLink={currentOpenLink} editionEndpoint={editionEndpoint} />
      </div>
    );
  }
}
